import { submitDtfEvent } from "common/utils/mixpanel/submit-dtf-events";
import PresetMockupColorPicker from "./PresetMockupColorPicker.vue";
import { MAX_PRINT_SIZES_GROUPED } from "../common/constants";
import HorizontalScroller from "../common/HorizontalScroller.vue";
import ShirtMockup from "./ShirtMockup.vue";
import { useDtfStore } from "../store";
import { cn } from "tailwind-variants";
import { renderList } from "common/vue/render-list";
import "./PresetSelector.scss";

function PresetSelector({
  sizePresets = [],
  selectedPresets = ["custom"],
  disabled = false,
  index = 0,
  onSelect,
  ...restProps
}) {
  const store = useDtfStore();

  // Computed properties as functions
  function artworks() {
    return store.artworks;
  }

  function isStandardArtwork() {
    return store.isStandardArtwork;
  }

  function presetMockupColor() {
    return store.presetMockupColor;
  }

  function artwork() {
    return artworks()[index];
  }

  function artworkUrl() {
    return artwork().url;
  }

  function hasInvalidPresets() {
    return sizePresets.length < Object.keys(MAX_PRINT_SIZES_GROUPED).length;
  }

  function selectedColor() {
    return presetMockupColor()[index];
  }

  // Methods
  function isSelected(preset) {
    return selectedPresets.includes(preset);
  }

  function isLastPreset(preset) {
    return selectedPresets.length === 1 && selectedPresets[0] === preset;
  }

  function submitEvent(preset) {
    const action = isSelected(preset) ? "deselected" : "selected";
    submitDtfEvent("common_size_pressed", {
      sizeName: preset,
      action
    });
  }

  function handleSelect(e) {
    if (disabled) return;
    const { preset, isValid } = e.target.dataset;
    if (isLastPreset(preset) || !isValid) return;
    submitEvent(preset);
    onSelect?.({
      preset,
      sizes: MAX_PRINT_SIZES_GROUPED[preset]
    });
    const container = e.target.closest(".preset-selector__items");
    if (container) {
      container.scrollLeft = e.target.offsetLeft;
    }
  }

  return (
    <div
      {...restProps}
      className="preset-selector preset-selector--mockup scope-338f2c4e"
      onClick={handleSelect}
      data-testid="preset-selector-mockup"
    >
      <HorizontalScroller
        className="preset-selector__items scope-338f2c4e"
        data-testid="preset-selector-items"
      >
        {renderList(sizePresets, sizePreset => (
          <div
            className={cn("preset-selector__item scope-338f2c4e", {
              "preset-selector__item--selected": isSelected(sizePreset.id),
              "preset-selector__item--invalid": !sizePreset.isValid,
              "preset-selector__item--standard-artwork": isStandardArtwork()
            })}
            key={sizePreset.id}
            data-preset={sizePreset.id}
            data-is-valid={sizePreset.isValid}
          >
            <ShirtMockup
              className="scope-338f2c4e"
              artworkUrl={artworkUrl()}
              preset={sizePreset.id}
              selectedColor={selectedColor()}
              data-testid="shirt-mockup"
            />

            <div className="preset-selector__title scope-338f2c4e">{sizePreset.title}</div>
          </div>
        ))}
      </HorizontalScroller>
      {hasInvalidPresets() ? (
        <div className="preset-selector__error-info scope-338f2c4e">
          {" "}
          *Some sizes are unavailable. Minimum size is 1 inch.{" "}
        </div>
      ) : null}
      <PresetMockupColorPicker
        className="scope-338f2c4e"
        index={index}
        data-testid="preset-mockup-color-picker"
      />
    </div>
  );
}

export default PresetSelector;
